import {CustomCode} from "../../model/common.model";

export class NotificationStatusCode extends CustomCode{
  public static _registered = new Map<string, NotificationStatusCode>();
  static AWAITING_DISTRIBUTION = new NotificationStatusCode('AWAITING_DISTRIBUTION');
  static DISTRIBUTED = new NotificationStatusCode('DISTRIBUTED');
  static ACCEPTED = new NotificationStatusCode('ACCEPTED');
  static QUEUED = new NotificationStatusCode('QUEUED');
  static SENDING = new NotificationStatusCode('SENDING');
  static SENT = new NotificationStatusCode('SENT');
  static RECEIVING = new NotificationStatusCode('RECEIVING');
  static RECEIVED = new NotificationStatusCode('RECEIVED');
  static DELIVERED = new NotificationStatusCode('DELIVERED');
  static UNDELIVERED = new NotificationStatusCode('UNDELIVERED');
  static FAILED = new NotificationStatusCode('FAILED');


  static ALL = Array.from(NotificationStatusCode._registered.values());

  constructor(code: string) {
    super(code);
    NotificationStatusCode._registered.set(code, this);
  }
  static retrieveFromCode(code: string): NotificationStatusCode {
    const res = NotificationStatusCode._registered.get(code);
    if (!res) {
      console.log('NotificationStatusCode can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  public toTranslateKey(): string{
    return 'NOTIFICATION_STATUS_' + this.code;
  }


}
